import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.orders')
  .factory('$order', OrderObjectFactory);

/* @ngInject */
function OrderObjectFactory($bringozFactory: $bringozFactory,
                            OrdersAPI: BringozApi) {

  function $order(id: string) {
    return $bringozFactory(id, OrdersAPI);
  }

  return $order;
}
